import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import {Button, Col, Form, Row, Select, Space, Table, Typography} from "antd";
import {
  allColumns,
  itemsInputField as inputFieldsInit,
} from "./DivisionWork.config";
import {useAppDispatch, useAppSelector} from "../../../../../../redux/hooks";

import Notification from "../../../../../../components/common/notification/notification";
import {ExpandSearch, Search} from "../../../../../../components/common";
import {ExcelSVG, SaveWhiteIconSVG} from "../../../../../../assets";
import "./style.scss";
import {
  generateFileName,
  isApproveRecord,
  saveTableOptions,
} from "../../../../../../helper/common";
import axiosClient from "../../../../../../api/_";
import employeeService from "api/employee";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import {render} from "react-dom";
import {data} from "data/env";
import columns from "../../../../../Refractive/InforDetails/DryAutoRefraction/FillBtn/config";
import {getListCauHinh, getPhongBanAPI, searchChamCong, searchPhanCa} from "redux/reducer/employee";
import Icons from "assets/icons";
import eBCSlice from "../../../../../../redux/reducer/examBtnClick";
import { setButtonsHeader } from "redux/reducer/common";
import usePermission from "hooks/usePermission";
import ExpandSearchHCNS from "components/common/ExpandSearch/ExpandSearchHCNS";
import { log } from "console";
const DivisionWork = () => {
  const [showDescriptions, setShowDescriptions] = useState(false);
  const { isNhanVien, isQuanLy, isGiamDoc } = usePermission();
  const toggleDescriptions = () => {
    setShowDescriptions(!showDescriptions);
  };
  const today = new Date();
  const currentYear = today.getFullYear(); // Lấy năm hiện tại (ví dụ: 2023)
  const currentMonth = today.getMonth() + 1; // Lấy tháng hiện tại (0 - 11, cần cộng thêm 1 để có giá trị tháng thực tế)
  const [fields, setFields] = useState(inputFieldsInit);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    nam: currentYear,
    thang: currentMonth,
    limit: 1000,
    idPhongBan: null,
    hoTen:null,
    maNv:null,
  // tuan: 1,
  });
  const activeTab = useAppSelector((e) => e.common.activeTab);
  const [fieldInfo, setFieldInfo] = useState(inputFieldsInit);
  const [selectedShift, setSelectedShift] = useState(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [newMonth, setMonths] = useState<null>();
  const [newYear, setYear] = useState<null>();
  const [optionsShift, setoptionsShift] = useState<any[]>();
  const [paramss, setParamss] = useState<any>({});
  const employees = useAppSelector(state => state.employeesReducer);
  const [record, setRecord] = useState(null);
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const [dateOfMonth, setDateOfMonth] = useState([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [columns, setColumns] = useState<any>(
    allColumns.filter(e => e.show == true)
  );
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [total, setTotal] = useState(0);
  columns.find(e => e.dataIndex === "index").render = (text, record, index) => {
    const rowNumber = (currentPage - 1) * params.limit + index + 1;
    return rowNumber;
  };
  const onClickSearch = async () => {
    await form.validateFields();
    setCurrentPage(1);
    var searchFields = expandRef?.current?.getData();
    setParams({...params, ...searchFields, page: 1}); // Đặt trang về 1 khi thực hiện tìm kiếm
  };
  useEffect(() => {
    expandRef?.current.setFieldValue("nam", currentYear);
    expandRef?.current.setFieldValue("thang", currentMonth);
    // expandRef?.current.setFieldValue("tuan", 1);
  }, []);
  const getList = async () => {
    setLoading(true);
    setSelectedRowKeys([]);
    await dispatch(searchPhanCa(params));
    setLoading(false);
  };
  // const getList = async (page = 1, limit = 1000,idPhongBan =params.idPhongBan,hoTen=params.hoTen,thang=params.thang,nam=params.nam,maNv=params.maNv) => {
  //   setLoading(true);
  //   try {
  //     const paramss = { page, limit,idPhongBan,hoTen,thang,nam,maNv };
  //     const response = await employeeService.getShiftList(paramss)
  //     .then(res => {
  //       setData(res.data.items);
  //       setTotal(res.data);
  //     });
  //     setLoading(false);
  //   } catch (error) {
  //     Notification(
  //       "error",
  //       "Đã có lỗi xảy ra khi load danh sách phân ca làm việc"
  //     );
  //     setLoading(true);
  //   }
  // };
  useEffect(() => {
    setData(
      employees.PhanCaList.map((rowData) => {
        return {
          ...rowData,
          key: rowData.id,
        };
      })
    );
  }, [employees.PhanCaList]);
  const handleSave = (row: any) => {
    const newData = [...data];
    const index = newData.findIndex(item => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setData(newData);
  };
  useEffect(() => {
    dispatch(
      getListCauHinh({
        page: 1,
        limit: 1000,
      })
    );
  }, []);
  // useEffect(() => {
  //   setOptionsCauHinhFields(employees.CauHinhCa, "");
  // }, [employees.CauHinhCa]);
  // const setOptionsCauHinhFields = (list, kyHieu) => {
  //   if (inputFieldsInit.find(field => field.name === kyHieu)) {
  //     inputFieldsInit.find(field => field.name === kyHieu).options =
  //       list?.map(item => ({
  //         value: item.id,
  //         label: item.kyHieuCa,
  //       }));
  //   }
  // };
  useEffect(() => {
    dispatch(
      getPhongBanAPI({
        page: 1,
        limit: 100,
      })
    );
  }, []);
  useEffect(() => {
    setOptionsPBFields(employees.phongBanList, "idPhongBan");
  }, [employees.phongBanList]);
  const setOptionsPBFields = (list, tenPhongBan) => {
    if (inputFieldsInit.find(field => field.name === tenPhongBan)) {
      inputFieldsInit.find(field => field.name === tenPhongBan).options =
        list?.map(item => ({
          value: item.id,
          label: item.tenPhongBan,
        }));
    }
  };
  useEffect(() =>{
    dispatch(setButtonsHeader([]));
  },[])
  useEffect(() => {
    getList();
  }, [params,activeTab]);
  const nam = params.nam;
  const thang = params.thang;
  // const tuan = params.tuan;
  const filteredColumns = allColumns.filter(e => e.dataIndex === "tuan");
  filteredColumns.forEach(column => {
    column.title = "Tháng " + thang + " Năm " + nam;
  });
  // function getAllDatesInMonth(year, month) {
  //   const startDate = new Date(year, month - 1, 1); // month is 0-indexed
  //   const endDate = new Date(year, month, 0);
  //   const dates = [];
  //   let currentWeek = [];

  //   while (startDate <= endDate) {
  //     currentWeek.push(new Date(startDate)); // clone the date object
  //     if (startDate.getDay() === 0) {
  //       // Sunday
  //       dates.push([...currentWeek]);
  //       currentWeek = [];
  //     }
  //     startDate.setDate(startDate.getDate() + 1);
  //   }

  //   // Add the remaining days in the last week
  //   if (currentWeek.length > 0) {
  //     dates.push([...currentWeek]);
  //   }

  //   return dates;
  // }
  function getAllDatesInMonth(year, month) {
    const startDate = new Date(year, month - 2, 21); // month is 0-indexed
    const endDate = new Date(year, month - 1, 20);
    const dates = [];
    while (startDate <= endDate) {
      dates.push(new Date(startDate)); // clone the date object
      startDate.setDate(startDate.getDate() + 1);
    }

    return dates;
  }
  useEffect(() => {
    // Lấy ngày từ tháng trc tới tháng sau
   // getList()
    const datesInFebruary2023 = getAllDatesInMonth(nam, thang);
    const dateOfMonth = [];
    datesInFebruary2023.map(e => {
      //Check ngày trong tuần
      const dayOfWeek = e.getDay();
      dateOfMonth.push({
        title: e.getDate(),
        width: 65,
        align: "center",
        className: "white",
        children: [
          {
            title: () => {
              switch (dayOfWeek) {
                case 0:
                  return "CN";
                case 1:
                  return "T2";
                case 2:
                  return "T3";
                case 3:
                  return "T4";
                case 4:
                  return "T5";
                case 5:
                  return "T6";
                case 6:
                  return "T7";
              }
            },
            key: `day${e.getDate()}`,
            show: true,
            dataIndex: `day${e.getDate()}`,
            width: 65,
            align: "center",
            className: dayOfWeek === 0 || dayOfWeek === 6 ? "green blue" : "white",
          },
        ],
      });
    });
    if (dateOfMonth) {
      columns.find(item => item.dataIndex === "tuan").children = dateOfMonth;
    }
  }, [thang, nam]);
  // useEffect(()=>{
  //   renderColumns();
  // },[])
  useEffect(() => {
    const fetchData = async () => {
      // Đặt loading là true để hiển thị trạng thái loading
      setLoading(true);
      columns.map(async record => {
        if (record.dataIndex == "tuan") {
          if (record.children) {
            const paramss = {page: 1, limit: 1000};
            const response = await employeeService.getShiftWorkSetting(paramss);
            const shiftOptions = response.map(shift => ({
              value: shift.id,
              label: shift.kyHieuCa,
            }));
            shiftOptions.unshift({
              value: 0,
              label: '0'
            });
            for (let i = 0; i < record.children.length; i++) {
              const dataIndex = record.children[i].children.find(
                item => item.dataIndex
              );
              if (dataIndex) {
                if (dataIndex) {
                  switch (dataIndex.dataIndex) {
                    case "day21":
                    case "day22":
                    case "day23":
                    case "day24":
                    case "day25":
                    case "day26":
                    case "day27":
                    case "day28":
                    case "day29":
                    case "day30":
                    case "day31":
                    case "day1":
                    case "day2":
                    case "day3":
                    case "day4":
                    case "day5":
                    case "day6":
                    case "day7":
                    case "day8":
                    case "day9":
                    case "day10":
                    case "day11":
                    case "day12":
                    case "day13":
                    case "day14":
                    case "day15":
                    case "day16":
                    case "day17":
                    case "day18":
                    case "day19":
                    case "day20":
                      dataIndex.render = (value, record, index) => (
                        <Select
                          className="Select-divisionWork"
                          style={{
                            width: "100%",
                            backgroundColor:
                              value === "x" ? "#f1f1f153" : "white",
                            borderRadius: "5px",
                          }}
                          options={shiftOptions}
                          value={value}
                          onChange={(e, option: any) => {
                            const fieldName = dataIndex.dataIndex;
                            setData(prevDataTable => {
                              return prevDataTable.map((prevItem, ind) =>
                                ind === index
                                  ? {
                                      ...prevItem,
                                      [fieldName]: option.label,
                                    }
                                  : prevItem
                              );
                            });
                          }}
                          disabled={value === "x" || isApproveRecord(record)}
                        ></Select>
                      );
                  }
                }
              }
            }
          }
        }
      });
      // Thực hiện các thao tác với columns ở đây
      getList();
      // Đặt loading là false sau khi hoàn thành thao tác
      setLoading(false);
    };
    fetchData();
  }, [loading,params]); // useEffect sẽ gọi lại mỗi khi loading thay đổi
  // const renderColumns = async () => {
  //   setLoading(true);
  //   columns.map(async record => {
  //     if (record.dataIndex == "tuan") {
  //       if (record.children) {
  //         const paramss = {page: 1, limit: 1000};
  //         const response = await employeeService.getShiftWorkSetting(paramss);
  //         const shiftOptions = response.map(shift => ({
  //           value: shift.id,
  //           label: shift.kyHieuCa,
  //         }));
  //         for (let i = 0; i < record.children.length; i++) {
  //           const dataIndex = record.children[i].children.find(
  //             item => item.dataIndex
  //           );
  //           if (dataIndex) {
  //             if (dataIndex) {
  //               switch (dataIndex.dataIndex) {
  //                 case "day21":
  //                 case "day22":
  //                 case "day23":
  //                 case "day24":
  //                 case "day25":
  //                 case "day26":
  //                 case "day27":
  //                 case "day28":
  //                 case "day29":
  //                 case "day30":
  //                 case "day31":
  //                 case "day1":
  //                 case "day2":
  //                 case "day3":
  //                 case "day4":
  //                 case "day5":
  //                 case "day6":
  //                 case "day7":
  //                 case "day8":
  //                 case "day9":
  //                 case "day10":
  //                 case "day11":
  //                 case "day12":
  //                 case "day13":
  //                 case "day14":
  //                 case "day15":
  //                 case "day16":
  //                 case "day17":
  //                 case "day18":
  //                 case "day19":
  //                 case "day20":
  //                   dataIndex.render = (value, record, index) => (
  //                     <Select
  //                       style={{
  //                         width: "100%",
  //                         backgroundColor:
  //                           value === "x" ? "#f1f1f153" : "white",
  //                         borderRadius: "5px",
  //                       }}
  //                       options={shiftOptions}
  //                       value={value}
  //                       onChange={(e, option: any) => {
  //                         const fieldName = dataIndex.dataIndex;
  //                         setData(prevDataTable => {
  //                           return prevDataTable.map((prevItem, ind) =>
  //                             ind === index
  //                               ? {
  //                                   ...prevItem,
  //                                   [fieldName]: option.label,
  //                                 }
  //                               : prevItem
  //                           );
  //                         });
  //                       }}
  //                       disabled={value === "x" || isApproveRecord(record)}
  //                     ></Select>
  //                   );
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   });
  //   setLoading(false);
  // };
  // const result = getAllDatesInMonth(nam, thang);
  // console.log(result);
  // useEffect(() => {
  //   getTuanList();
  // }, [thang, nam]);
  // const getTuanList = async (page = 1, limit = 1000) =>{
  //   setLoading(true);
  //   try {
  //     setLoading(true);
  //     const datesInSelectedMonth = getAllDatesInMonth(nam, thang);
  //     const dateOfMonth = [];
  //     const selectedWeek = params.tuan || 1;
  //     const selectedWeekDates = datesInSelectedMonth[selectedWeek - 1] || [];
  //     const paramss = { page, limit };
  //     const response = await employeeService.getShiftWorkSetting(paramss);
  //     const shiftOptions = response.map((shift) => ({
  //       value: shift.id,
  //       label: shift.kyHieuCa,
  //     }));
  //     selectedWeekDates.forEach((e) => {
  //       setLoading(true);
  //       // Check ngày trong tuần
  //       const dayOfWeek = e.getDay();
  //       const dataIndexz =
  //         dayOfWeek === 0
  //           ? "rankCN"
  //           : dayOfWeek === 1
  //           ? "rank2"
  //           : dayOfWeek === 2
  //           ? "rank3"
  //           : dayOfWeek === 3
  //           ? "rank4"
  //           : dayOfWeek === 4
  //           ? "rank5"
  //           : dayOfWeek === 5
  //           ? "rank6"
  //           : dayOfWeek === 6
  //           ? "rank7"
  //           : `rank${dayOfWeek}`;
  //       const datass =
  //         dayOfWeek === 0
  //           ? "chuNhat"
  //           : dayOfWeek === 1
  //           ? "thu2"
  //           : dayOfWeek === 2
  //           ? "thu3"
  //           : dayOfWeek === 3
  //           ? "thu4"
  //           : dayOfWeek === 4
  //           ? "thu5"
  //           : dayOfWeek === 5
  //           ? "thu6"
  //           : dayOfWeek === 6
  //           ? "thu7"
  //           : `thu${dayOfWeek}`;
  //       dateOfMonth.push({
  //         title: e.getDate(),
  //         width: 100,
  //         align: "center",
  //         className: "white",
  //         dataIndex: "tuanNgay",
  //         disable:false,
  //         children: [
  //           {
  //             title: "",
  //             key: dataIndexz,
  //             show: true,
  //             dataIndex: dataIndexz,
  //             width: 70,
  //             align: "center",
  //             className: "white",
  //             children: [
  //               {
  //                 type: "COMBO_BOX",
  //                 title: () => {
  //                   switch (dayOfWeek) {
  //                     case 0:
  //                       return "CN";
  //                     case 1:
  //                       return "T2";
  //                     case 2:
  //                       return "T3";
  //                     case 3:
  //                       return "T4";
  //                     case 4:
  //                       return "T5";
  //                     case 5:
  //                       return "T6";
  //                     case 6:
  //                       return "T7";
  //                     default:
  //                       return "";
  //                   }
  //                 },
  //                 key: datass,
  //                 show: true,
  //                 dataIndex: datass,
  //                 width: 70,
  //                 align: "center",
  //                 className: "white",
  //                 render:(text, value, index) =>{
  //                   const selectedShift = response.find((e) => e.id == text);
  //                   return (
  //                     <Select
  //                       style={{ width: "100%" }}
  //                       defaultValue={selectedShift ? selectedShift.id : undefined}
  //                       options={shiftOptions}
  //                       value={text}
  //                       onChange={(e, shift: any) => {
  //                         const fieldName = datass;
  //                       //

  //                         setData((prevDataTable) => {
  //                           return prevDataTable.map((prevItem, ind) =>
  //                             ind == index
  //                               ? {
  //                                   ...prevItem,
  //                                   [fieldName]: shift.value,
  //                                 }
  //                               : prevItem
  //                           );
  //                         });
  //                       }}
  //                     ></Select>
  //                   )
  //                 }
  //               },
  //             ],
  //           },
  //         ],
  //       });
  //       setLoading(false);

  //     });

  //     if (dateOfMonth.length > 0) {
  //       const tuanColumn = columns.find((item) => item.dataIndex === "tuan");
  //       if (tuanColumn) {
  //         tuanColumn.children = dateOfMonth;
  //       }
  //     }
  //         setLoading(false);
  //       } catch (error) {
  //         setLoading(false);
  //         Notification(
  //           "error",
  //           "Đã có lỗi xảy ra khi load danh sách chi tiết thông tin"
  //         );
  //       }
  // }
  // const getListConfigShift = async (page = 1, limit = 1000) => {
  //   setLoading(true);
  //   try {
  //     // ...
  //     const params = { page, limit };
  //     const response = await employeeService.getShiftWorkSetting(params);
  //     const shiftOptions = response.map((shift) => ({
  //       value: shift.id,
  //       label: shift.kyHieuCa,
  //     }));
  //     dateOfMonth.map((e) => {
  //       if (e.dataIndex === "tuanNgay") {

  //         e.children.map((item) => {
  //           if (
  //             item.dataIndex === "rank2" ||
  //             item.dataIndex === "rank3" ||
  //             item.dataIndex === "rank4" ||
  //             item.dataIndex === "rank5" ||
  //             item.dataIndex === "rank6" ||
  //             item.dataIndex === "rank7" ||
  //             item.dataIndex === "rankCN"
  //           ) {
  //             console.log(item);
  //             item.children[0].render = (text, value, index) => {
  //               const selectedShift = response.find((e) => e.id == text);
  //               return (
  //                 <Select
  //                   style={{ width: "100%" }}
  //                   defaultValue={selectedShift ? selectedShift.id : undefined}
  //                   options={shiftOptions}
  //                   value={text}
  //                   onChange={(e, shift: any) => {
  //                     const fieldName = item.children[0].dataIndex;
  //                     setData((prevDataTable) => {
  //                       return prevDataTable.map((prevItem, ind) =>
  //                         ind == index
  //                           ? {
  //                               ...prevItem,
  //                               [fieldName]: shift.value,
  //                             }
  //                           : prevItem
  //                       );
  //                     });
  //                   }}
  //                 ></Select>
  //               );
  //             };
  //           }
  //         });
  //       }
  //     });
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     Notification(
  //       "error",
  //       "Đã có lỗi xảy ra khi load danh sách chi tiết thông tin"
  //     );
  //   }
  // };
  // useEffect(() => {
  //   getListConfigShift();
  // }, [data]);

  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({...params, page: currentPage, limit: pageSize});
  };
  const onClickExport = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({...params, ...searchFields});
    handleExportExcel(params);
  };

  const handleExportExcel = async params => {
    const url = "hanhchinhnhansu/phan-ca/export-excel";
    const baseName = "danh-sach-phan-ca-lam-viec";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Lỗi khi tải xuống file excel");
    }
  };
  const OnAdd = async () => {
    setLoading(true);
    try {
      const response = await employeeService.phatSinhChamCong(params);
      if (response.data.code == 200) {
        Notification("success", "thêm bảng chấm công thành công");
        getList();
        setLoading(false);
      } else {
        Notification("warning", response.data.message);
        getList();
        setLoading(false);
      }
    } catch (err) {
      Notification("error", "Lỗi khi thêm bảng chấm công");
      setLoading(false);
    }
  };
  const handleOnAdd = () => {
    setRecord(null);
  };
  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const excel = event.target.files[0];
      const formData = new FormData();
      formData.append("files", excel);
      try {
        const response = await employeeService.uploadPhanCa(formData);
        if (response.data.code == 400) {
          Notification("error", response.data.message);
          setLoading(false);
        }
        else
        {
          Notification("success", "Tải file excel lên thành công");
          setLoading(false);
        }
        getList();
      } catch (err) {
        Notification("error", "Lỗi khi tải lên file excel");
        setLoading(false);
      }
    }
  };
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await employeeService.editShiftList(data);
      //console.log(params);
      getList();
      Notification("success", "Cập nhập thành công ");
      setLoading(false);
    } catch (res) {
      Notification("error", "Cập nhập thất bại");
      setLoading(false);
    }
  };

  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  const onFinish = value => {};
  // useEffect(() => {
  //   fields.find((e) => e.name === "thang").onChange = (e) => {
  //     setMonths(e);
  //   };

  //   fields.find((e) => e.name === "nam").onChange = (e) => {
  //     setYear(e);
  //   };
  //   fields.find((e) => e.name === "tuan").onChange = (e, option: any) => {
  //     setTuan(option.label);
  //   };
  // }, [fields]);
  const setShowColumnsList = showColumns => {
    saveTableOptions(
      "RECEIVED_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    //   setColumns(showColumns);
  };
  // useEffect(() => {
  //   const tuanField = fields.find((e) => e.name === "tuan");
  //   if (tuanField) {
  //     tuanField.options = changeWeek(newMonth, newYear);
  //     setFields((prevFields) => {
  //       const updatedFields = prevFields.filter((field) => {
  //         if (field.name === "tuan") {
  //           setTuan(field.value);
  //           return tuanField; // Cập nhật trường "tuan"
  //         }
  //         return field;
  //       });
  //       return updatedFields;
  //     });
  //   }
  // }, [newMonth, newYear]);
  //Khi load trang thì lấy được tất cả dữ liệu của tháng và năm

  return (
    <Form form={form}>
      <div className="recruitment-list" tabIndex={0}>
        <div className="recruitment-container">
          <div className="container" onKeyDown={onKeyDown}>
            <ExpandSearchHCNS
              ref={expandRef}
              fields={inputFieldsInit}
              onClickSearch={onClickSearch}
              // Ẩn nút "Tìm kiếm nâng cao"
              isSearchExpend={false}
              isResetField={false}
            />
          </div>
          <div className="container">
            <Space style={{width: "100%"}} direction="vertical">
              <Row justify={"end"} gutter={[16, 8]}>
                <Button
                  className="btn-sub"
                  type="primary"
                  icon={<Icons.add />}
                  onClick={OnAdd}
                >
                  Phát sinh bảng công
                </Button>
                <Col>
                  <Button
                    className="custom-btn"
                    type="default"
                    onClick={onClickExport}
                    icon={<ExcelSVG />}
                  >
                    <Typography>Xuất báo cáo</Typography>
                  </Button>
                </Col>
                <input
                  type="file"
                  style={{display: "none"}}
                  onChange={handleUpload}
                  ref={fileInputRef}
                />
                <Button
                  icon={<Icons.upload />}
                  className="btn-sub"
                  type="primary"
                  onClick={handleClick}
                  style={{
                    width: "100px",
                    marginRight: "7px",
                  }}
                >
                  Import
                </Button>
                <Button
                  className="custom-btn"
                  type="primary"
                  htmlType="submit"
                  onClick={handleSubmit}
                  icon={<SaveWhiteIconSVG />}
                  disabled={isNhanVien() || isQuanLy() || isGiamDoc()}
                >
                  Lưu lại
                </Button>
              </Row>
              {data && (
                <CustomResizableTable
                  setShowColumns={setShowColumnsList}
                  pagination={{
                    position: ["bottomRight"],
                    showSizeChanger: true,
                    total: employees.PhanCaTotal,
                    onChange: onChangePagination,
                    current: currentPage,
                  }}
                  rowKey={record => record.id}
                  columns={columns}
                  dataSource={data}
                  bordered={true}
                  loading={loading}
                  scroll={{x: 3000}}
                 // size="middle"
                />
              )}
            </Space>
          </div>
        </div>
      </div>
    </Form>
  );
};
export default DivisionWork;
